import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../localization";
import Image from "../../components/image";
import Button from "../../components/button";
import { getUrl } from "../../utils/helper";
import { getMe } from "../../redux/selectors/me";

class Project extends Component {
    _renderImage(url) {
        const { locale } = this.props;

        if (!url) return null;

        return (
            <div className="absolute top-0 right-0 left-0 bottom-0 z-0">
                <div className="w-full h-full overflow-hidden">
                    <Image
                        alt={Localization[locale].info.project_title}
                        url={url}
                        aspectRatio={null}
                    />
                </div>
            </div>
        );
    }

    _renderLinks() {
        const { locale } = this.props;

        return (
            <div className="xl:flex mt-40">
                <Button
                    text={Localization[locale].info.artistic}
                    backgroundColorOver={"bg-orange"}
                    borderColor={"border-orange"}
                    to={getUrl("opencalls/artistic")}
                    textStyle={
                        "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-orange"
                    }
                    style={"mt-8 xl:mt-8 xl:mr-30"}
                    wrapperStyle="px-30 xl:px-15"
                />
                <Button
                    text={Localization[locale].info.technic}
                    backgroundColorOver={"bg-orange"}
                    borderColor={"border-orange"}
                    to={getUrl("opencalls/technic")}
                    textStyle={
                        "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-orange"
                    }
                    style={"mt-8 xl:mt-8 xl:mr-30"}
                    wrapperStyle="px-30 xl:px-15"
                />
                <Button
                    text={Localization[locale].info.claim}
                    backgroundColorOver={"bg-orange"}
                    borderColor={"border-orange"}
                    to={getUrl("opencalls/claim")}
                    textStyle={
                        "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-orange"
                    }
                    style={"mt-8 xl:mt-8 xl:mr-30"}
                    wrapperStyle="px-30 xl:px-15"
                />
                <Button
                    text={Localization[locale].info.space}
                    backgroundColorOver={"bg-orange"}
                    borderColor={"border-orange"}
                    to={getUrl("spaces_booking")}
                    textStyle={
                        "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-orange"
                    }
                    style={"mt-8 xl:mt-8 xl:mr-30"}
                    wrapperStyle="px-30 xl:px-15"
                />
                <Button
                    text={Localization[locale].info.classes}
                    backgroundColorOver={"bg-orange"}
                    borderColor={"border-orange"}
                    to={getUrl("practices")}
                    textStyle={
                        "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-orange"
                    }
                    style={"mt-8 xl:mt-8 xl:mr-30"}
                    wrapperStyle="px-30 xl:px-15"
                />
            </div>
        );
    }

    render() {
        const { infoData, locale } = this.props;

        if (!infoData) return null;

        return (
            <div
                className={
                    "flex flex-col items-center justify-center py-60 xl:py-0 xl:h-screen relative bg-blue"
                }
            >
                {infoData.image && this._renderImage(infoData.image.url)}
                <h1
                    className={
                        "font-judge font-bold uppercase text-center text-50 w-250 xl:w-auto xl:text-100 z-10 text-orange"
                    }
                >
                    {Localization[locale].info.project_title}
                </h1>
                {this._renderLinks()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    infoData: state.pages.info,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Project);
